import { enums } from 'console-kit';

import displayContainerConstants from './display-container-constants';

const { LIGHTBOX_EVENT_CONFIG_TYPE, LIGHTBOX_LAUNCH_METHOD } = displayContainerConstants;

export const PICKER_STYLES = {
  height:    175,
  width:     262,
  margin:    '0 40px 20px 40px',
  textAlign: enums.textAlignments.CENTER,
};

export const DEFAULT_TIME_ON_PAGE = '10';

export const DEFAULT_SCROLL = '50';

export const SCROLL_OPTIONS = [
  {
    label: '25%',
    value: '25',
  },
  {
    label: `${DEFAULT_SCROLL}%`,
    value: DEFAULT_SCROLL,
  },
  {
    label: '75%',
    value: '75',
  },
];

export const LIGHTBOX_LAUNCH_DEFAULT_BUTTON_DATA = {
  text:        'Button',
  textColor:   '#394242',
  buttonColor: '#d4d9d9',
};

export const LIGHTBOX_LAUNCH_DEFAULT_LINK_DATA = {
  text:      'Placeholder Text',
  textColor: '#3c8fb2',
};

export const LIGHTBOX_LAUNCH_DEFAULT_EVENT_DATA = {
  eventType:        LIGHTBOX_EVENT_CONFIG_TYPE.PAGE_LOAD,
  timeOnPage:       DEFAULT_TIME_ON_PAGE,
  scrollPercentage: DEFAULT_SCROLL,
};

export const OVERLAY_SIZE = {
  FIXED:    'fixed',
  ADAPTIVE: 'adaptive',
};

export const MAX_CHARS = {
  BUTTON: 20,
  LINK:   20,
};

export const DEFAULT_LIGHTBOX_CONFIG = {
  launchMethod: LIGHTBOX_LAUNCH_METHOD.BUTTON,
  ...LIGHTBOX_LAUNCH_DEFAULT_BUTTON_DATA,
};

export const PUBLISHING_EVENT_STEP_FORM = 'publishingEventStep';

export const PUBLISHING_EDITOR_FORM = 'publishingEditor';

export default {
  PICKER_STYLES,
  DEFAULT_TIME_ON_PAGE,
  DEFAULT_SCROLL,
  SCROLL_OPTIONS,
  LIGHTBOX_LAUNCH_DEFAULT_BUTTON_DATA,
  LIGHTBOX_LAUNCH_DEFAULT_LINK_DATA,
  LIGHTBOX_LAUNCH_DEFAULT_EVENT_DATA,
  OVERLAY_SIZE,
  MAX_CHARS,
  DEFAULT_LIGHTBOX_CONFIG,
  PUBLISHING_EVENT_STEP_FORM,
  PUBLISHING_EDITOR_FORM,
};